// An italic paragraph directly under an image is its caption: smaller and
// dimmed, so it reads as part of the image rather than the article.
.markdown :global(p:has(> img) + p:has(> em:only-child)) {
	margin-top: calc(var(--mantine-spacing-md) * -0.5);
	font-size: var(--mantine-font-size-sm);
	color: var(--mantine-color-dimmed);
	line-height: 1.5;
}
